import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WishListIcon from '../../../../../CommonComponents/ProductCard/WishListIcon';
import { setToastMessage, shortlist } from '../../../../../actionCreators/common';
import './SideBarFooter.scss';
import { v4 } from 'uuid';
import { odPushGA4Event } from '../../../../../utils/gaFour';
import { odPushClevertapEvent } from '../../../../../utils/clevertap';
import ProductServiceHighlights from './../../../../../own-days/CommonComponents/Product/ProductHighlightsModal/ProductHighlightsModal';
import { getProductCurrency, getProductPrice } from '../../../../../own-days/helper';
import { odPushTTQEvent } from '../../../../../utils/tiktokPixel';
import StoreAvailability from '../StoreAvailability/StoreAvailability';
import '../../../../../own-days/CommonComponents/OdButton/OdButton.scss';
import earnPointsIcon from './../../../../../../static/assets/svg/od-earn-points.svg';

const SideBarFooter = ({ setSlMessage, isShortlisted, wishlistCount, productData }) => {
  const dataLocale = useSelector(state => state.locale);
  const {
    FREE_SHIPPING,
    ONE_YEAR_WARRANTY_PDP = 'One-year warranty',
    EARN,
    POINTS,
    SL_EXCEEDED_MESSAGE,
    SUCCESSFULLY_REMOVED,
    SUCCESSFULLY_ADDED,
    FIND_IN_STORE,
    SECURE_PAYMENT,
  } = dataLocale;
  const login = useSelector(state => state.common.login);
  const userInfo = useSelector(state => state.common.userInfo);

  const [showHighlightsModal, setShowHighlightsModal] = useState(false);
  const [storeAvailability, setStoreAvailability] = useState(false);

  const dispatch = useDispatch();

  const wishListHandler = event => {
    event.preventDefault();
    event.stopPropagation();

    sessionStorage.setItem('hideshortlistinfo', true);

    if (!isShortlisted && wishlistCount >= 50) {
      dispatch(setToastMessage({ message: SL_EXCEEDED_MESSAGE, timeout: 2000 }));

      return;
    }

    if (isShortlisted) {
      dispatch(shortlist(null, 'delete', `/${productData.id}`));

      setSlMessage({ message: SUCCESSFULLY_REMOVED, timeout: 3000 });

      odPushClevertapEvent('Removed From Wishlist', {
        productID: productData?.id,
        productName: productData?.fullName,
        category: productData?.classification,
        price: getProductPrice(productData),
        currency: getProductCurrency(productData),
        brand: productData?.brandName,
        variant: productData?.modelName,
        productURL: productData?.url,
        imageURL: productData?.thumbnailImage,
      });
    } else {
      dispatch(shortlist(productData.id, 'post', ''));

      setSlMessage({ message: SUCCESSFULLY_ADDED, timeout: 3000 });

      odPushClevertapEvent('Added To Wishlist', {
        productID: productData?.id,
        productName: productData?.fullName,
        category: productData?.classification,
        price: getProductPrice(productData),
        currency: getProductCurrency(productData),
        brand: productData?.brandName,
        variant: productData?.modelName,
        productURL: productData?.url,
        imageURL: productData?.thumbnailImage,
      });

      const gaPLPSelectItemData =
        JSON.parse(sessionStorage.getItem('ga-plp-select-item-data')) || {};

      odPushGA4Event('add_to_wishlist', {
        userInfo,
        productData,
        gaPLPSelectItemData,
      });

      odPushTTQEvent('AddToWishlist', {
        userInfo,
        productData,
      });
    }

    if (window.dtm.LenskartRewamp) {
      if (isShortlisted) {
        window.dtm.LenskartRewamp.Listing.click.removeProdcutShortlist(
          login,
          productData.id.toString()
        );
      } else {
        window.dtm.LenskartRewamp.Listing.click.shortlist(productData.id.toString());
      }
    }
  };

  const additionalBlockData = useMemo(
    () => [
      {
        title: 'Free shipping',
        img: {
          src: 'https://static1.lenskart.com/owndays/img/pdp/package-delivered.svg',
          alt: 'Free shipping',
        },
      },
      {
        title: '1 Year warranty',
        img: {
          src: 'https://static1.lenskart.com/owndays/img/pdp/shield-protect.svg',
          alt: 'warranty',
        },
      },
      ...(productData?.estimatePoints?.membershipPoints &&
      productData?.estimatePoints?.rebatePercent
        ? [
            {
              title: `${EARN} ${productData?.estimatePoints?.membershipPoints} ${POINTS} (${productData?.estimatePoints?.rebatePercent}%)`,
              img: {
                src: earnPointsIcon,
                alt: 'Earn points',
              },
            },
          ]
        : []),
    ],
    [productData?.estimatePoints?.membershipPoints, productData?.estimatePoints?.rebatePercent]
  );

  useEffect(() => {
    const wishlist = document.querySelector('.sidebar__footer__main__wishList');
    const target = document.querySelector('.product-top__left-actions');

    if (wishlist && target) {
      target.appendChild(wishlist);
    }
  }, []);

  return (
    <div className="sidebar__footer">
      <div className="sidebar__footer__main">
        <div className="sidebar__footer__main__wishList" onClick={wishListHandler}>
          <WishListIcon
            customStyles={{ fontSize: '24px' }}
            dataLocale={dataLocale}
            device="desktop"
            isShortlisted={isShortlisted}
            wishListMode="secondary"
          />
        </div>
        <button
          className="odButton odButton--outline odButton--fluid"
          onClick={() => {
            setStoreAvailability(true);
          }}
        >
          FIND IN STORE
        </button>
      </div>
      {productData?.classification !== 'accessories_revenue' && (
        <div className="sidebar__footer__additional">
          <div className="sidebar__footer__additional__items">
            {additionalBlockData.map(block => {
              const { src, alt } = block.img;
              return (
                <div
                  key={v4()}
                  className="sidebar__footer__additional__items__item"
                  onClick={() => setShowHighlightsModal(true)}
                >
                  <img alt={alt} src={src} />
                  <p>{block.title}</p>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <StoreAvailability
        setStoreAvailability={setStoreAvailability}
        storeAvailability={storeAvailability}
      />
      <ProductServiceHighlights
        setShowHighlightsModal={setShowHighlightsModal}
        showHighlightsModal={showHighlightsModal}
      />
    </div>
  );
};

export default SideBarFooter;
